import React from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import {
  PuzzleCellState,
  selectPuzzleAnswer,
} from '../../../redux/puzzle-slice';

interface PuzzleCellProps {
  x: number;
  y: number;
  className?: string;
  onPointerDown: (evt: React.PointerEvent, x: number, y: number) => void;
  onPointerMove: (evt: React.PointerEvent) => void;
  onPointerUp: (evt: React.PointerEvent, x: number, y: number) => void;
}

const PuzzleCell: React.FC<PuzzleCellProps> = ({
  x,
  y,
  className,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  ...props
}) => {
  const answer = useSelector(selectPuzzleAnswer);
  const value = answer[x][y];

  const handlePointerDown = React.useCallback((evt: React.PointerEvent) => {
    if (onPointerDown) {
      onPointerDown(evt, x, y);
    }
  }, [onPointerDown, x, y]);

  const handlePointerUp = React.useCallback((evt: React.PointerEvent) => {
    if (onPointerUp) {
      onPointerUp(evt, x, y);
    }
  }, [onPointerUp, x, y]);

  return (
    <td
      className={classnames(
        'cursor-pointer	w-5 h-5 touch-none',
        className,
        value === PuzzleCellState.On &&
          'bg-gray-600 dark:bg-gray-400 puzzle-cell-on',
      )}
      onPointerDown={handlePointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={handlePointerUp}
      {...props}
      onContextMenu={e => e.preventDefault()}
      data-row={y}
      data-col={x}
    >
      {value === PuzzleCellState.Off && (
        <div className='w-full h-full flex items-center justify-center'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            className='inline-block w-4 h-4 text-red-600 fill-current'
            aria-hidden='true'
          >
            <path
              fill='currentColor'
              d='M6.343 4.929a1.2 1.2 0 0 0-1.697 1.697L10.303 12l-5.657 5.374a1.2 1.2 0 1 0 1.697 1.697L12 13.697l5.657 5.374a1.2 1.2 0 0 0 1.697-1.697L13.697 12l5.657-5.374a1.2 1.2 0 1 0-1.697-1.697L12 10.303 6.343 4.929Z'
            />
          </svg>
        </div>
      )}
    </td>
  );
};

export default PuzzleCell;
